import { render } from "./Paycode.vue?vue&type=template&id=5d8887c2&scoped=true"
import script from "./Paycode.vue?vue&type=script&lang=js"
export * from "./Paycode.vue?vue&type=script&lang=js"

import "./Paycode.vue?vue&type=style&index=0&id=5d8887c2&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d8887c2"]])

export default __exports__